var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('g', {
      attrs: {
        "fill-rule": "nonzero",
        "fill": "none"
      }
    }, [_c('path', {
      attrs: {
        "d": "M16.65 14.283h-4.667a.669.669 0 01-.666-.666c0-.367.3-.667.666-.667h4.667c.367 0 .667.3.667.667 0 .366-.3.666-.667.666z",
        "fill": "#00A4EA"
      }
    }), _c('path', {
      attrs: {
        "d": "M11.858 14.267c-.525-.109-.716-.759-.35-1.142l1.225-1.258a.686.686 0 01.634-.192c.525.108.716.758.35 1.142l-1.225 1.258a.693.693 0 01-.634.192zm.125 1.016h4.667c.367 0 .667.3.667.667 0 .367-.3.667-.667.667h-4.667a.669.669 0 01-.666-.667c0-.367.3-.667.666-.667z",
        "fill": "var(--mainColor)"
      }
    }), _c('path', {
      attrs: {
        "d": "M16.775 15.3c.525.108.717.758.35 1.142L15.9 17.7a.686.686 0 01-.633.192c-.525-.109-.717-.759-.35-1.142l1.225-1.258a.693.693 0 01.633-.192zM9.983 1.667A4.837 4.837 0 005.15 6.5a4.837 4.837 0 004.833 4.833A4.837 4.837 0 0014.817 6.5a4.831 4.831 0 00-4.834-4.833zm0 8.333a3.5 3.5 0 110-7 3.5 3.5 0 010 7z",
        "fill": "var(--mainColor)"
      }
    }), _c('path', {
      attrs: {
        "d": "M3.433 17.9a.587.587 0 00.584-.592V17.3a5.971 5.971 0 015.966-5.967V10a7.298 7.298 0 00-7.3 7.3v.025c0 .317.267.575.584.575h.166z",
        "fill": "#00A4EA"
      }
    })])]));
  }
};